import { type CarSortOptionEnum, useCarListSort } from "@apac/cars";
import { useModuleBEM } from "@b2bportal/core-themes";
import { RadioGroup } from "@tenant/ui";
import styles from "./FilterListSort.module.scss";

type FilterListSortProps = {
  selectedSort: CarSortOptionEnum;
  onChange: (value: CarSortOptionEnum) => void;
};

export const FilterListSort = ({
  selectedSort,
  onChange,
}: FilterListSortProps) => {
  const [block, cn] = useModuleBEM(styles, "FilterListSort");

  const {
    context: { sortOptions },
  } = useCarListSort();

  return (
    <div className={block}>
      <RadioGroup
        className={cn("radio-group")}
        defaultValue={selectedSort}
        onSelectValue={onChange}
        options={sortOptions}
      />
    </div>
  );
};
